import React from 'react';
import PageLayout from '../components/common/page-layout';

export default function Dashboard() {
  return <PageLayout pageTitle="داشبورد"></PageLayout>;
}
